import { useState, useEffect, useCallback } from 'react';

const THEME_KEY = 'pyzone-theme';

const themes = {
  daybreak: {
    id: 'daybreak',
    name: 'יום בהיר',
    nameEn: 'Daybreak',
    icon: '☀️',
    description: 'נקי ורענן',
    className: '',
  },
  midnight: {
    id: 'midnight',
    name: 'חצות',
    nameEn: 'Midnight',
    icon: '🌙',
    description: 'כהה ומסתורי',
    className: 'midnight',
  },
  colorful: {
    id: 'colorful',
    name: 'צבעוני',
    nameEn: 'Colorful',
    icon: '🌈',
    description: 'עליז וחי',
    className: 'colorful',
  },
  hacker: {
    id: 'hacker',
    name: 'האקר',
    nameEn: 'Hacker',
    icon: '💻',
    description: 'סגנון מטריקס',
    className: 'hacker',
  },
  vscode: {
    id: 'vscode',
    name: 'הייטקיסט',
    nameEn: 'High-Tech Pro',
    icon: '🔷',
    description: 'סגנון VS Code',
    className: 'vscode',
  },
};

export const useTheme = () => {
  const [theme, setThemeState] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(THEME_KEY);
      return saved && themes[saved] ? saved : 'daybreak';
    }
    return 'daybreak';
  });

  // Apply theme to document
  useEffect(() => {
    const root = document.documentElement;
    
    // Remove all theme classes
    Object.values(themes).forEach(t => {
      if (t.className) {
        root.classList.remove(t.className);
      }
    });
    
    // Add current theme class
    const currentTheme = themes[theme];
    if (currentTheme.className) {
      root.classList.add(currentTheme.className);
    }
    
    // Save to localStorage
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const setTheme = useCallback((newTheme) => {
    if (themes[newTheme]) {
      setThemeState(newTheme);
    }
  }, []);

  const cycleTheme = useCallback(() => {
    const themeOrder = ['daybreak', 'midnight', 'colorful', 'hacker', 'vscode'];
    const currentIndex = themeOrder.indexOf(theme);
    const nextIndex = (currentIndex + 1) % themeOrder.length;
    setTheme(themeOrder[nextIndex]);
  }, [theme, setTheme]);

  return {
    theme,
    setTheme,
    cycleTheme,
    themes,
    currentTheme: themes[theme],
  };
};
